
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"38","height":"38","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"19","cy":"19","r":"19","fill":"#0FB400"}}),_c('path',{attrs:{"d":"M18.022 11.569a3.964 3.964 0 00-3.959 3.96c0 1.198.536 2.274 1.38 3 0-2.345-.004-2.182.01-2.343a2.655 2.655 0 012.57-3.31 2.655 2.655 0 012.57 3.31c.012.156.009.081.009 1.54.224.002.442.034.65.092.459-.647.73-1.438.73-2.29a3.964 3.964 0 00-3.96-3.96z","fill":"#fff"}}),_c('path',{attrs:{"d":"M18.022 9a6.536 6.536 0 00-6.528 6.528 6.538 6.538 0 003.949 5.997v-1.458a5.225 5.225 0 01-2.642-4.539 5.227 5.227 0 015.221-5.221 5.227 5.227 0 015.222 5.221 5.19 5.19 0 01-.849 2.85 2.573 2.573 0 011.491.018c.425-.866.665-1.84.665-2.868 0-3.6-2.929-6.528-6.529-6.528z","fill":"#fff"}}),_c('path',{attrs:{"d":"M25.445 20.39a1.06 1.06 0 00-1.06 1.06v-.594a1.273 1.273 0 00-2.545 0v-.552a1.273 1.273 0 00-2.545 0v-3.902a1.273 1.273 0 00-2.545 0v10.79c0 1.006.74 1.808 1.808 1.808h6.188c1.068 0 1.76-.929 1.76-1.654V21.45a1.06 1.06 0 00-1.06-1.06z","fill":"#fff"}})])
          )
        }
      }
    